import axios from 'axios';
import * as Constants from '../common/constants';
import * as HelperFunctions from '../common/functions/helperFunctions';
import { UserPersonalDataModel } from '../models/user/userPersonalDataModel';
import AuthService from './authService';

class UserPersonalDataService {

  authService = new AuthService();

  constructor() {
    //axios.defaults.baseURL = `${Constants.apiUrl}`;
    axios.defaults.headers = {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: `Bearer ${this.authService.getToken()}`,
      Pragma: 'no-cache'
    }
  }

  getUserPersonalData(id: number) {
    return axios({
      url: `${Constants.apiUrl}/userPersonalData/get/${id}`,
      method: 'get',
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Authorization: `Bearer ${this.authService.getToken()}`,
        Pragma: 'no-cache'
      }
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  updateUserPersonalData(user: UserPersonalDataModel) {
    return axios({
      url: `${Constants.apiUrl}/userPersonalData/update/`,
      method: 'put',
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Authorization: `Bearer ${this.authService.getToken()}`,
        Pragma: 'no-cache'
      },
      data: JSON.stringify(user)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }


}

export default UserPersonalDataService;